import * as S from './styles'

//const checkNf = (trackingList) => {
//  return trackingList.find((e) => e.PedidoSituacao === 'EMISSAO_DE_NOTA_FISCAL')
//}

export const VisualizarNota = ({ seller, pedido, documento }) => {
  return (
    <>
      {
        //checkNf(seller.Tracking) !== undefined ||
        seller.NumeroNotaFiscal != null && seller.NumeroNotaFiscal > 0 ? (
          <S.ButtonNFSemaforo
            onClick={() => {
              if (seller.SellerNome === 'Gimba') {
                window.open(
                  `https://notasfiscais.gimba.com.br/notasfiscais.asp?nota=${seller.NumeroNotaFiscal}&cpfcnpj=${documento}&tipo=pdf`
                )
              } else {
                if (
                  seller?.NotaFiscal?.LinkDANFE === '' ||
                  seller?.NotaFiscal?.LinkDANFE === null
                ) {
                  window.open(
                    `https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ+gAVw2g=&nfe=${seller?.NotaFiscal?.Chave}`
                  )
                } else {
                  window.open(`${seller?.NotaFiscal?.LinkDANFE}`)
                }
              }
            }}
          >
            (BAIXE AQUI)
          </S.ButtonNFSemaforo>
        ) : (
          ''
        )
      }
    </>
  )
}

export const AcompanharEntrega = ({ seller, delivery }) => {
  return (
    <>
      {delivery ? (
        <S.ButtonNFSemaforo
          onClick={() => {
            const validateUrl = /https?:\/\//g
            const regex = new RegExp(validateUrl)

            if (seller.SellerNome === 'Gimba') {
              window.open(
                `https://rastreamento.correios.com.br/app/index.php?objetos=${seller.Envio.CodigoRastreio}`
              )
            } else if (seller.Envio.RastreioUrl.match(regex)) {
              window.open(seller.Envio.RastreioUrl)
            } else if (
              seller.Envio.Transportadora.toLowerCase().includes('correios')
            ) {
              window.open(
                `https://rastreamento.correios.com.br/app/index.php?objetos=${seller.Envio.CodigoRastreio}`
              )
            } else {
              window.open(`//${seller.Envio.RastreioUrl}`)
              // window.open(seller.Envio.RastreioUrl, '_blank')
            }
          }}
        >
          (RASTREAR)
        </S.ButtonNFSemaforo>
      ) : null}
    </>
  )
}
